import { bindings } from '@polleverywhere/slideware-bindings'
import appRoleToUserRole from '../../util/app_role_to_user_role'
import {
  appendParamsToSSOLink,
  environment,
  openSSOPopover,
  outOfBandLogin
} from './util'

function samlIssuer (url) {
  const issuerUrl = new URL(url)
  // It could either come as:
  // pe.com/auth/company
  // pe.com/auth/saml/company
  // Get rid of both if it exists
  return issuerUrl.pathname.replace('/auth/', '').replace('saml/', '')
}

export default async function (options = {}) {
  const { role, url } = options
  const context = environment({ role })
  switch (context) {
    case 'agave': {
      const authUrl = await outOfBandLogin(() => window.location.reload(), {
        provider: 'saml',
        samlIssuer: samlIssuer(url)
      })

      if (window.Office?.UI?.openBrowserWindow) {
        window.Office.UI.openBrowserWindow(authUrl)
      } else {
        window.open(authUrl, '', 'resizable,scrollbars,status')
      }
      break
    }

    case 'desktop': {
      const authUrl = await outOfBandLogin(() => window.location.reload(), {
        provider: 'saml',
        samlIssuer: samlIssuer(url)
      })

      await bindings.openBrowser({ url: authUrl })
      break
    }

    case 'mobile':
      openSSOPopover(appendParamsToSSOLink(url, appRoleToUserRole(role)))
      break

    default:
      window.location.href = appendParamsToSSOLink(url, appRoleToUserRole(role))
      break
  }
}
